/**
 * Exceptions we cannot act on: they come from browser extensions, in-app
 * browsers or blocked third-party scripts, not from our code. Dropping them
 * keeps App Insights (and the browser-exceptions alert) focused on real errors.
 */
const EXTENSION_SCHEMES = [
  'chrome-extension://',
  'moz-extension://',
  'safari-web-extension://',
  'safari-extension://',
  'iabjs://', // in-app browser (e.g. Android webview helpers)
];

const NOISE_MESSAGES = [
  'Script error', // cross-origin error, no details available
  'googletag is not defined', // GPT blocked by adblocker/extension
  'Java object is gone', // Android in-app browser bridge
];

type ExceptionDetails = {
  message?: string;
  typeName?: string;
  stack?: string;
  parsedStack?: Array<{ assembly?: string; fileName?: string }>;
};

export function isNoiseException(exceptions: ExceptionDetails[] | undefined): boolean {
  if (!exceptions?.length) return false;

  return exceptions.some((ex) => {
    const text = [
      ex.message,
      ex.typeName,
      ex.stack,
      ...(ex.parsedStack ?? []).flatMap((frame) => [frame.assembly, frame.fileName]),
    ]
      .filter(Boolean)
      .join('\n');

    return (
      EXTENSION_SCHEMES.some((scheme) => text.includes(scheme)) ||
      NOISE_MESSAGES.some((msg) => text.includes(msg))
    );
  });
}
